import { render, staticRenderFns } from "./LogoIntegracao.vue?vue&type=template&id=062f9437&scoped=true"
import script from "./LogoIntegracao.vue?vue&type=script&lang=js"
export * from "./LogoIntegracao.vue?vue&type=script&lang=js"
import style0 from "./LogoIntegracao.vue?vue&type=style&index=0&id=062f9437&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062f9437",
  null
  
)

export default component.exports